export const Logo = () => {
  return (
    <svg
      id="_Слой_1"
      xmlns="http://www.w3.org/2000/svg"
      xmlns:xlink="http://www.w3.org/1999/xlink"
      viewBox="150 150 413.76 207.89"
      style={{width: "100%", height: "85px"}}
    >
      <style>{`
    .cls-1 { stroke-width: 2.14px; }
    .cls-1, .cls-2 { fill: #ed1c24; stroke: #ed1c24; stroke-linecap: round; stroke-linejoin: round; }
    .cls-2 { stroke-width: 2.17px; }
    .cls-3 { fill: url(#linear-gradient); }
  `}</style>
      <defs>
        <linearGradient
          id="linear-gradient"
          x1="175.92"
          y1="228.57"
          x2="537.84"
          y2="228.57"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0" stop-color="#ee3324" />
          <stop offset=".36" stop-color="#be202e" />
          <stop offset=".66" stop-color="#ee3324" />
          <stop offset="1" stop-color="#f37560" />
        </linearGradient>
      </defs>
      <path
        class="cls-3"
        d="M398.08,339.37l-167.17-176.71h-34.56l-20.43-20.43v-23.97h74.67l167.92,176.71h75.18v-156.76l20.18-20.43h23.96v221.6h-139.76ZM196.35,296.88l-20.43-20.43v-100.15h23.96l20.44,20.43v100.15h-23.97ZM412.46,272.52l-120.44-126.8v-17.15h47.17l126.25,132.61v11.35h-52.98Z"
      />
      <path
        class="cls-1"
        d="M181.57,366.08c.05,1.51.43,2.9,1.15,4.16.72,1.26,1.71,2.27,2.97,3.03,1.25.75,2.64,1.13,4.15,1.13s3-.35,4.3-1.04c1.3-.7,2.33-1.67,3.1-2.92.77-1.25,1.15-2.65,1.15-4.19,0-1.12-.26-2.2-.77-3.25s-1.21-1.92-2.08-2.62c-.86-.7-1.78-1.24-2.74-1.61s-2.17-.75-3.63-1.12c-1.76-.47-3.19-.92-4.27-1.33-1.08-.41-2.08-1.02-3-1.81-2.31-1.96-3.46-4.53-3.46-7.71,0-2.17.52-4.1,1.57-5.79,1.05-1.69,2.46-3,4.25-3.93,1.79-.93,3.76-1.4,5.91-1.4s3.95.49,5.69,1.47c1.74.98,3.12,2.33,4.13,4.04,1.01,1.71,1.52,3.6,1.52,5.66h-4.3c-.09-1.38-.47-2.62-1.14-3.72-.67-1.1-1.55-1.96-2.65-2.56s-2.35-.91-3.75-.91c-1.3,0-2.5.33-3.59.97-1.09.65-1.95,1.53-2.58,2.63-.63,1.11-.94,2.3-.94,3.59,0,1.54.37,2.77,1.12,3.71.75.94,1.68,1.65,2.79,2.13,1.11.48,2.53.96,4.25,1.43,2.17.6,3.78,1.1,4.81,1.5,1.04.4,2.08,1.07,3.12,2.02,1.22,1.05,2.17,2.34,2.84,3.87.68,1.54,1.02,3.13,1.02,4.79,0,2.22-.58,4.25-1.73,6.1-1.16,1.85-2.7,3.3-4.62,4.36-1.93,1.06-4,1.6-6.22,1.6s-4.46-.52-6.42-1.57c-1.96-1.05-3.51-2.51-4.66-4.39-1.15-1.88-1.72-3.99-1.72-6.33h4.42Z"
      />
      <path
        class="cls-1"
        d="M245.87,346.97c-1.01-1.53-2.29-2.84-3.84-3.95-1.55-1.11-3.24-1.94-5.06-2.51s-3.66-.85-5.52-.85c-3.05,0-5.9.8-8.56,2.39-2.66,1.6-4.78,3.72-6.35,6.38-1.57,2.66-2.36,5.47-2.36,8.42,0,3.14.8,6.05,2.41,8.75,1.61,2.7,3.76,4.83,6.47,6.42,2.71,1.58,5.6,2.37,8.66,2.37,2.77,0,5.44-.69,8.01-2.06s4.67-3.2,6.3-5.48h4.58c-1.19,2.28-2.77,4.29-4.74,6.03-1.97,1.74-4.18,3.08-6.62,4.04-2.45.96-4.96,1.44-7.53,1.44-2.97,0-5.78-.54-8.42-1.62-2.64-1.08-4.95-2.6-6.95-4.56-2-1.96-3.55-4.26-4.65-6.9-1.1-2.64-1.66-5.45-1.66-8.42,0-3.83.96-7.37,2.88-10.61s4.51-5.82,7.79-7.71c3.27-1.9,6.83-2.84,10.68-2.84,4.46,0,8.43,1.16,11.89,3.46,1.46.92,2.89,2.1,4.29,3.55,1.4,1.45,2.35,2.87,2.87,4.27h-4.58Z"
      />
      <path
        class="cls-1"
        d="M275.32,336.35h4.58l17.71,41.29h-4.47l-5.97-13.86h-19.22l-5.97,13.86h-4.47l17.83-41.29ZM285.53,360.05l-7.92-18.95-8.05,18.95h15.97Z"
      />
      <path
        class="cls-1"
        d="M306.32,336.35h11.12c3.32.03,6.3.39,8.93,1.1,2.64.71,5.06,1.94,7.27,3.7,1.55,1.28,2.9,2.77,4.03,4.46s2,3.51,2.61,5.45c.6,1.94.91,3.89.91,5.84s-.27,3.89-.8,5.74c-.53,1.85-1.3,3.6-2.31,5.23-1.01,1.63-2.22,3.1-3.64,4.4-2.3,2.08-4.77,3.5-7.42,4.24-2.65.75-5.74,1.12-9.29,1.12h-11.4v-41.29ZM315.77,373.9c2.36-.04,4.3-.12,5.82-.27,1.51-.14,3.05-.48,4.6-1.02,1.55-.54,3.05-1.38,4.5-2.52,2.03-1.59,3.59-3.53,4.68-5.8,1.1-2.28,1.66-4.74,1.68-7.39-.05-5.37-2.2-9.72-6.42-13.07-2.06-1.6-4.2-2.63-6.44-3.08s-5.04-.67-8.42-.67h-5.32v33.81h5.32Z"
      />
      <path
        class="cls-1"
        d="M365.93,336.35h4.58l17.71,41.29h-4.47l-5.97-13.86h-19.22l-5.97,13.86h-4.47l17.83-41.29ZM376.15,360.05l-7.92-18.95-8.05,18.95h15.97Z"
      />
      <path
        class="cls-2"
        d="M415.01,359.16h10.11v1.67h-8.26v6.66h7.98v1.67h-7.98v6.81h8.26v1.67h-10.11v-18.49Z"
      />
      <path
        class="cls-2"
        d="M439.6,368.19l-5.91-9.03h2.15l4.9,7.4,4.88-7.4h2.15l-5.98,9.03,6.36,9.45h-2.18l-5.23-7.9-5.25,7.9h-2.17l6.28-9.45Z"
      />
      <path
        class="cls-2"
        d="M456.85,359.16h4.85c.7,0,1.33.03,1.86.07.54.04,1.07.13,1.6.27s1.02.36,1.49.66c.79.49,1.39,1.14,1.8,1.94.42.8.62,1.67.62,2.61,0,1.83-.7,3.26-2.1,4.28-.65.48-1.36.8-2.12.96-.76.16-1.66.24-2.68.24h-3.48v7.46h-1.85v-18.49ZM461.89,368.51c.81,0,1.51-.05,2.09-.14.58-.09,1.13-.3,1.63-.61.51-.32.91-.75,1.2-1.31s.43-1.15.43-1.77c0-.79-.2-1.49-.61-2.1s-.97-1.05-1.69-1.35c-.68-.29-1.54-.43-2.6-.43-.14,0-.35,0-.63.01s-.49.01-.62.01h-2.38v7.68h3.18Z"
      />
      <path
        class="cls-2"
        d="M478.27,359.16h10.11v1.67h-8.26v6.66h7.98v1.67h-7.98v6.81h8.26v1.67h-10.11v-18.49Z"
      />
      <path
        class="cls-2"
        d="M498.27,359.16h4.4c1.17,0,2.16.05,2.98.16.82.11,1.58.35,2.27.75.93.53,1.64,1.25,2.13,2.14.49.9.74,1.89.74,2.98,0,.99-.24,1.9-.73,2.75-.49.84-1.15,1.51-1.98,2.02s-1.75.77-2.74.79l5.2,6.9h-2.3l-6.28-8.38h.55c.9,0,1.66-.03,2.29-.09.63-.06,1.21-.2,1.73-.41.76-.35,1.35-.86,1.77-1.51.42-.66.63-1.4.63-2.24,0-.64-.16-1.26-.46-1.86-.31-.6-.73-1.08-1.26-1.44-.54-.39-1.13-.63-1.76-.73-.63-.1-1.44-.15-2.41-.15h-2.93v16.81h-1.85v-18.49Z"
      />
      <path
        class="cls-2"
        d="M522.59,360.83h-4.25v-1.67h10.3v1.67h-4.2v16.81h-1.85v-16.81Z"
      />
    </svg>
  );
};
